import { Breadcrumbs, Typography } from "@mui/material";
import { AppConfig } from "environement";

export const maxWidth = 1220;
export const testimonialImage = 60;

export const premiumBaseRate = 100;
export const additionalWorkSessionBaseRate = 20;
export const goldenWorkSessionRateForTier1 = 60;
export const goldenWorkSessionRateForTier2 = 120;
export const premiumWorkSessionCount = 5;
export const starterWorkSessionCount = 2;

export const featureSmsPrice = 25;
export const featureWhiteLabelPrice = 25;
export const featureCustomPipelinePrice = 30;
export const featureProjectInvitePrice = 50;
export const featurePdfAutofillPrice = 50;
export const featureAutopilotPrice = 50;
export const featureDashboardPrice = 20;

export const tier1Name = "Overture";
export const tier2Name = "Mezzo";
export const tier3Name = "Finale";
export const addonName = "Premium Features";
export const goldenWSName = "Premium Work Session";

export const pricingHeaders = [
  {
    id: 1,
    title: "",
  },
  {
    id: 2,
    title: tier1Name,
    description:
      "The best way to get started with Rhapsody. Send calls to small groups of musicians.",
    idealFor: "Ideal for chamber ensembles, weddings & small gigs.",
    buttonText: "",
    href: "https://start.live.rhapsody.la/about-you",
    price: "$0",
    priceDescription: " free forever",
  },
  {
    id: 3,
    title: tier2Name,
    description:
      "Sends calls for bigger orchestras. Increase your musician database.",
    idealFor: "Ideal for churches & freelance contractors.",
    recommanded: true,
    dynamic: true,
    href: `${AppConfig.stripe.mezzo}`,
    price: `$${premiumBaseRate}`,
    buttonText: "Subscribe Now",
  },
  {
    id: 4,
    title: tier3Name,
    description:
      "Rhapsody unleashed. Everything included. Everything unlimited. Comes with professional support.",
    idealFor: "Ideal for universities, orchestras & large organizations.",
    href: "https://forms.gle/1HkQZswAYsFpdiXP8",
    buttonText: "Request a Quote",
    price: "Quote Based",
  },
];

export const iconForPlan = {
  overture: <i className="fa-solid fa-house-window"></i>,
  mezzo: <i className="fa-solid fa-building"></i>,
  finale: <i className="fa-solid fa-city"></i>,
};

export const pricingContent = [
  {
    id: 1,
    content: [
      {
        id: 1,
        title: "Work Sessions",
        whatIsIt: (
          <>
            <Typography variant="body2">
              Our pricing model is based on what we call a <b>Work Session</b>{" "}
              which is basically a group of musicians playing on a date and
              location. A Work Session can be a rehearsal, a concert, a
              recording session, or whatever!
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: 8,
              }}
            >
              <Breadcrumbs separator="-">
                <Typography variant="overline">
                  <i className="fad fa-users pright pleft"></i> 1 roster
                </Typography>
                <Typography variant="overline">
                  <i className="fad fa-calendar-day pright pleft"></i> 1 date
                </Typography>
                <Typography variant="overline">
                  <i className="fad fa-map-marker-alt pright pleft"></i> 1
                  location
                </Typography>
              </Breadcrumbs>
            </div>
            <Typography variant="caption" style={{ opacity: 0.58 }}>
              Examples: 35 musicians playing a recording session at Fox Studios
              is 1 Work Session
              <br /> 20 musicians playing 2 rehearsals and 1 concert is 3 Work
              Sessions.
            </Typography>
          </>
        ),
        plans: [
          {
            id: 1,
            infinite: true,
          },
          {
            id: 2,
            infinite: true,
            featured: true,
          },
          {
            id: 3,
            infinite: true,
          },
        ],
      },
      {
        id: 4,
        title: "Maximum chairs in a Work Session",
        plans: [
          {
            id: 10,
            title: "10",
          },
          {
            id: 11,
            title: "40",
            featured: true,
          },
          {
            id: 12,
            infinite: true,
          },
        ],
      },
      {
        id: 3,
        title: "# of contacts in your Address Book",
        tooltip:
          "This relates to the number of musicians you can store in Rhapsody's database. Rhapsody stores all contact information regarding musicians including instruments, phone numbers, emails, SSN and EIN's, and more!",
        plans: [
          {
            id: 7,
            title: "30",
          },
          {
            id: 8,
            featured: true,
            title: "100",
          },
          {
            id: 9,
            infinite: true,
          },
        ],
      },
      // {
      //   id: 9,
      //   title: "Maximum Pieces in a Project",
      //   plans: [
      //     {
      //       id: 10,
      //       title: "1",
      //     },
      //     {
      //       id: 11,
      //       title: "2",
      //       featured: true,
      //     },
      //     {
      //       id: 12,
      //       infinite: true,
      //     },
      //   ],
      // },
      {
        id: 2,
        title: "Additional users",
        tooltip: "The number of registered users who can access your account.",
        // tooltip:
        //   "Don't work alone! Give access to your organization to your assistant or other co-workers.",
        plans: [
          {
            id: 4,
            cross: true,
          },
          {
            id: 5,
            title: "1",
            featured: true,
          },
          {
            id: 6,
            infinite: true,
          },
        ],
      },
      {
        id: 7,
        title: "Custom Branding",
        icon: "fad fa-palette",
        whatIsIt: (
          <Typography variant="body2">
            With the <b>Custom Branding</b> feature, you can replace the
            auto-generated Rhapsody email and logo with your own. Once enabled,
            you can send emails from your personal email as well as include your
            logos for outgoing work calls, auto-generated rosters, and
            communications through Rhapsody.
          </Typography>
        ),
        definition: true,
        featureID: 4,
        rate: featureWhiteLabelPrice,

        plans: [
          {
            id: 19,
            cross: true,
          },
          {
            id: 20,
            cross: true,
            featured: true,
          },
          {
            id: 21,
            checked: true,
          },
        ],
      },
      // {
      //   id: 11,
      //   icon: "fad fa-robot",
      //   title: "Autopilot",
      //   whatIsIt: (
      //     <Typography variant="body2">
      //       When musicians decline your call, the <b>Autopilot</b> feature will
      //       automatically replace and contact the next-in-line musician. With
      //       this feature, you are able to configure a stack of alternate
      //       musicians for your project and Rhapsody will take care of notifying
      //       and communicating with alternative musicians so you don’t have to!
      //     </Typography>
      //   ),
      //   // subtitle: "Automate musicians communication",
      //   definition: true,
      //   featureID: 1,
      //   rate: featureAutopilotPrice,
      //   plans: [
      //     {
      //       id: 31,
      //       cross: true,
      //     },
      //     {
      //       id: 32,
      //       cross: true,
      //       featured: true,
      //     },
      //     {
      //       id: 33,
      //       checked: true,
      //     },
      //   ],
      // },
      {
        id: 12,
        icon: "fad fa-robot",
        title: "Report Form",
        definition: true,
        featureID: 1,
        rate: featureAutopilotPrice,
        tooltip:
          "Rhapsody helps you generate a report form after your sessions.",
        plans: [
          {
            id: 31,
            cross: true,
          },
          {
            id: 32,
            featured: true,
            title: "Basic only",
            subtitle: "PDF",
          },
          {
            id: 33,
            title: "Union's Continuation forms",
            subtitle: "PDF & Excel",
            checked: true,
          },
        ],
      },
      {
        id: 13,
        icon: "fad fa-robot",
        title: "Project PDF & Excel Export",
        definition: true,
        featureID: 1,
        rate: featureAutopilotPrice,
        plans: [
          {
            id: 31,
            cross: true,
          },
          {
            id: 32,
            featured: true,
            checked: true,
          },
          {
            id: 33,
            checked: true,
          },
        ],
      },
    ],
  },
];

export const faqContent = [
  {
    question: "What is a Project?",
    answer:
      'Projects answer the question "what am I hiring for?" It is the term used to house all data and information regarding hiring for a specific service(s) or event(s). For example, a concert with preceding rehearsals is a Project. A Project can also house items like recording sessions needed for a movie.',
  },
  {
    question: "What is a Work Session?",
    answer:
      "A Work Session is the term used to describe any singular date, event, or occasion where musicians need to attend/perform. These are things like rehearsals, concerts, recording sessions, etc.",
  },
  {
    question: "Can Rhapsody hire for me?",
    answer: (
      <span>
        Yes! Rhapsody offers a concierge service where we do all the hiring for
        you.{" "}
        <a target="_blank" rel="noreferrer" href="https://quote.rhapsody.la">
          Get an instant quote
        </a>
        .
      </span>
    ),
  },

  {
    question: "Can I get a demo of Rhapsody's workflow?",
    answer: (
      <span>
        Yes! We offer free demos of Rhapsody with no commitment so you can see
        how Rhapsody can work for your specific hiring and contracting needs.
        <a href="mailto:contact@rhapsody.la">Contact us</a> to schedule a demo.
      </span>
    ),
  },

  {
    question: "How do I sign up for Rhapsody?",
    answer:
      "Signing up for Rhapsody is easy! Check out our different plans on our pricing page to determine which plan is right for your needs.",
  },
];

export const pricingFaqContent = [
  // {
  //   question: "Is a rehearsal a Work Session?",
  //   answer:
  //     "It depens if the roster in the rehearsal is the same as the Work Session. If the answer is yes, you can embed the rehearsal in the Work Session. Otherwise the rehearsal is a Work Session.",
  // },
  {
    question: "What if I need more Work Sessions?",
    answer: `Work Sessions for ${tier1Name} and ${tier2Name} plans can be purchased at any time for $20/Work Session.`,
  },
  {
    question: "What is rollover?",
    answer: `Depending on your plan, Rhapsody offers rollover Work Sessions. If you are subscribed to the ${tier2Name} plan and did not use all 5 of your Work Sessions for the month, your remaining Work Session credits will be stored in your account. Credits will remain in your account as long as you are subscribed to the ${tier2Name} plan.`,
  },
  {
    question: `What is a ${goldenWSName}?`,
    answer: `A ${goldenWSName} lets you set up and plan a Work Session using every feature Rhapsody has to offer. ${tier1Name} and ${tier2Name} plans come with 1 free  ${goldenWSName} to try out these features and see how they make contracting even easier!`,
  },
  {
    question: `Can I add a ${goldenWSName} to my plan?`,
    answer: `Yes! ${tier1Name} and ${tier2Name} plans come with 1 free ${goldenWSName}. Additional ${goldenWSName} can be purchased for $${goldenWorkSessionRateForTier1}  for ${tier1Name} plan members, and$${goldenWorkSessionRateForTier2} for ${tier2Name} plan members.`,
  },
  {
    question: `What happens if I cancel my subscription?`,
    answer: `You can cancel your subscription at anytime. Any remaining Work Session credits in your account will remain available until your next billing cycle. Rhapsody will securely save your information in your account so that renewing your subscription is easy!`,
  },
  {
    question: `How much does it cost for Rhapsody to contract for me?`,
    answer: (
      <span>
        Rhapsody offers concierge services on a quote based system, specific to
        your needs. To request a quote for concierge services{" "}
        <a href="https://quote.rhapsody.la/" rel="noreferrer" target="_blank">
          click here
        </a>
      </span>
    ),
  },
  // {
  //   question: "Can I add a Premium feature at any time?",
  //   answer: "Yes, you can! Just purchase a Premium Feature when needed.",
  // },
  // {
  //   question: "How can I try a premium feature",
  //   answer: `After you create your account, we offer you a 1 ${goldenWSName} with all ${addonName} included for you to try.`,
  // },

  // {
  //   question: "Are additional Work Sessions refundable?",
  //   answer: "No",
  // },

  // {
  //   question: "Can I pause my subscription?",
  //   answer: "No, except in case of a global pandemic.",
  // },

  // {
  //   question: "How do I upgrade/downgrade?",
  //   answer: `Keep in mind that if you downgrade from ${tier2Name} to ${tier1Name}, you won't have rollover anymore, so all remaining /Work Sessions should be consumed before the end of the billing cycle. You will only have 2 /Work Sessions at the next billing cycle.`,
  // },
];

export const mainFeatures = [
  {
    id: 1,
    iconClass: "fad fa-steering-wheel",
    title: "Autopilot",
    catchPhrase: (
      <span>
        Rhapsody works late at night.
        <br />
        But you don&apos;t have to!
      </span>
    ),
    body: "Let Rhapsody replace musicians when they decline your call. Configure a stack of alternate musicians fyour project. Rhapsody will automatically contact the next-in-line musician.",
    link: true,
  },
  {
    id: 2,
    iconClass: "fad fa-chart-network",
    title: "Custom Pipelines",
    catchPhrase: (
      <span>
        Need a custom action in the Rhapsody workflow?
        <br />
        Doable!
      </span>
    ),
    body: "Rhapsody relies on a robust system called Mercury. Each invites follow a clear path in a workflow we designed to limit human mistakes. We offer a large variety of customization.",
    link: true,
  },
  {
    id: 3,
    iconClass: "fad fa-paper-plane",
    title: "Project Invite",
    catchPhrase: (
      <span>
        Having a complex schedule?
        <br />
        We have a simple way to send it out!
      </span>
    ),
    body: "Having multiple services to add in the call? With the project invite, you can send a full calendar schedule giving you all the flexibility you need.",
    link: true,
  },
  {
    id: 4,
    iconClass: "fad fa-palette ",
    title: "White Label",
    catchPhrase: (
      <span>
        Don&apos;t like our logo?
        <br />
        Fine. We like yours!
      </span>
    ),
    body: "Customize all your calls with your logo instead of Rhapsody's. We can also configure an SMTP relay so you can send emails using your domain name.",
    link: true,
  },
  {
    id: 5,
    iconClass: "fad fa-sms",
    title: "SMS",
    catchPhrase: (
      <span>
        Want a quick answer for your call?
        <br />
        Text musicians!
      </span>
    ),
    body: "There is many ways to send your call: email, push notifications but also SMS. Rhapsody is designed to be able to use any kind of gateway.",
    learnMore: <span></span>,
    link: true,
  },
  {
    id: 6,
    iconClass: "fad fa-file-pdf",
    catchPhrase: (
      <span>
        Let an algorithm do the boring task.
        <br />
        It won&apos;t complain!
      </span>
    ),
    title: "PDF Autofill",
    body: "Hiring a large group of musicians required to generate payroll documents and other administrative files. Rhapsody are able to fill them out automatically!",
    link: true,
  },
];

export const conciergeFeatures = [
  {
    id: 1,
    iconClass: "fad fa-steering-wheel",
    title: "Email, SMS & Push Notifications",
    body: "We don't only use emails to contact musicians. We send text messages and push notifications for musicians who are using our mobile app. We get lighntning fast answers!",
    link: false,
  },
  {
    id: 2,
    iconClass: "fad fa-chart-network",
    title: "24/7 Status Update",
    body: "Every concierge service comes with a private link where you can follow in live the progression. You'll see who accepted and who declined and the message they left.",
    link: false,
  },
  {
    id: 3,
    iconClass: "fad fa-paper-plane",
    title: "Auto Generated Rosters",
    body: "With a press of a button, Rhapsody generates an up-to-date Roster in PDF or CSV. We have a range of customization for this document to please all your needs.",
    link: false,
  },
  {
    id: 4,
    iconClass: "fad fa-palette ",
    title: "Expedited Urgent Call",
    body: "The more you use Rhapsody Concierge, the fastest it gets for us to send the call. Sending a call for a full ensemble takes no longer than an hour for one of our concierge.",
    link: false,
  },
  {
    id: 5,
    iconClass: "fad fa-sms",
    title: "Exclusive Concierge",
    body: "Your personal Rhapsody concierge will provide all the information you need. All our concierge are music professionals.",
    link: false,
  },
  {
    id: 6,
    iconClass: "fad fa-file-pdf",
    title: "Payroll Forms",
    body: "At the end of the session, we can export you any kind of data that could be helpfull. We can also pre-fill PDF such as report form.",
    link: false,
  },
];

export const acceptedPayments = [
  { iconClass: "fab fa-cc-visa", tooltip: "Visa" },
  { iconClass: "fab fa-cc-mastercard", tooltip: "Mastercard" },
  { iconClass: "fab fa-cc-discover", tooltip: "Discover" },
  { iconClass: "fab fa-cc-diners-club", tooltip: "Diners Club" },
  { iconClass: "fab fa-cc-jcb", tooltip: "JCB" },
  { iconClass: "fab fa-cc-amex", tooltip: "American Express" },
  { iconClass: "fab fa-cc-apple-pay", tooltip: "Apple Pay" },
];

const gradientCollection = {
  blue: "-webkit-linear-gradient(#03a9f4, #4dd0e1)",
  purple: "-webkit-linear-gradient(#ba68c8, #7986cb)",
  pink: "-webkit-linear-gradient(#ec407a, #e57373)",
  orange: "-webkit-linear-gradient(#ffb74d, #ffab91)",
  green: "-webkit-linear-gradient(#c5e1a5, #dce775)",
  teal: "-webkit-linear-gradient(#4db6ac, #1de9b6)",
  white: "-webkit-linear-gradient(#ffffff, #ececec)",
  rainbow:
    "linear-gradient(45deg, #ffb74d, #fff176, #c5e1a5, #90caf9, #9fa8da, #b39ddb, #e57373)",
};

export const featuresList = [
  {
    id: 1,
    titleVariant: "h4",
    titleSX: {},
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.blue,
      WebkitBackgroundClip: `text`,
      WebkitTextFillColor: `transparent`,
    },
    height: 250,
    tagID: [4, 7],
    icon: "fas fa-mobile",
    subtitle: (
      <span>
        Mobile app
        <br />
        for musicians
      </span>
    ),
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Musicians can manage their invites and see their upcoming services with our free mobile app. Available for iOS and Android, musicians can receive push notifications on new calls and any last-minute communications; all instantly to their phones!",
  },
  {
    id: 2,
    title: "Musician Address Book",
    titleVariant: "h3",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.purple,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 300,
    tagID: [7],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "All your musicians securely stored in one place. Import contacts from Google Contacts or VCF file and categorize your Address Book based on your hiring needs.",
  },
  {
    id: 3,
    title: "Mercury Pipeline",
    titleVariant: "",
    titleSX: { pb: 2 },
    icon: "fal fa-project-diagram",
    iconVariant: "h1",
    iconSX: {
      fontSize: "7rem !important",
      background: gradientCollection.blue,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 270,
    tagID: [3],
    subtitleSX: {},
    more: "Using a customized Mercury Pipeline specific for ensemble management, contractors and musicians send and respond to hiring requests following a specific path. Communication is clear and precise allowing zero chances for mistakes or miscommunication.",
  },
  {
    id: 4,
    title: "",
    titleVariant: "",
    titleSX: {},
    icon: "fas fa-lock-alt",
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.pink,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 240,
    tagID: [8],
    subtitleSX: {},
    more: "Sensitive information is fully encrypted using the AES-256 method. Data is securely stored and your connection with the Rhapsody server is secure with an SSL certificate.",
  },
  {
    id: 5,
    title: "Instant Roster",
    titleVariant: "h2",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.white,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 300,
    tagID: [1, 6],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Preview and download your Roster in PDF/CSV at any time, even if it is not fully completed! Rosters can be sent in your calls for musicians to review as well as used for concert programs.",
  },
  {
    id: 6,
    title: "",
    titleVariant: "",
    titleSX: {},
    icon: "fas fa-sms",
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.green,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [4],
    subtitleSX: {},
    premium: true,
    more: "In addition to sending emails, Rhapsody is equipped to send SMS text messages directly to musicians' phones. Musicians can reply through the links provided in the message, ensuring that you get rapid answers from every musician.",
  },
  {
    id: 7,
    icon: "fas fa-calendar-day",
    subtitle: "Full Availability Hiring",
    iconVariant: "h2",
    iconSX: {
      background: gradientCollection.teal,
      WebkitBackgroundClip: "text",
      fontSize: "96px !important",
      WebkitTextFillColor: "transparent",
    },
    height: 290,
    tagID: [],
    subtitleSX: { pt: 2 },
    more: "When you need to hire musicians who can attend every rehearsal, Rhapsody invites can send your full schedule to the musicians. This way, you are only contracting the musicians who have full availability.",
  },
  {
    id: 8,
    subtitle: "Nudges",
    icon: "fas fa-bullhorn",
    iconVariant: "h2",
    iconSX: {
      background: gradientCollection.green,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 200,
    tagID: [4],
    subtitleSX: { pt: 2 },
    more: "Waiting too long for an answer can be annoying. With Rhapsody, you can follow up with a musician by sending nudges, reminding them to reply to your invite.",
  },
  {
    id: 9,
    subtitle: "Attachments & Links",
    icon: "fas fa-paperclip",
    iconVariant: "h2",
    iconSX: {
      background: gradientCollection.white,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 200,
    tagID: [4],
    subtitleSX: { pt: 2 },
    more: "Want to upload music, PDF's, or maps to send to your musicians? How about Dropbox or Google Drive links? Absolutely! Rhapsody handles all documents and files you want to share ensuring your musicians get all the information they need.",
  },
  {
    id: 10,
    title: "Autofill",
    titleVariant: "h3",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.blue,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 200,
    tagID: [1, 3],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Autofill helps to prioritize contacting your first-call musicians. Select the personnel you want to contact based on customizable groups, templates, or previous hiring Projects and Rhapsody fills the Chairs with musicians in seconds!",
  },
  {
    id: 11,
    titleVariant: "",
    titleSX: { pb: 1 },
    icon: "far fa-robot",
    iconVariant: "h1",
    premium: true,
    title: "Autopilot",
    iconSX: {
      background: gradientCollection.green,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [1, 3],
    subtitleSX: {},
    more: "Don't you hate it when a musician can't make it to your event, forcing you to cycle through a list of alternates to fill the spot? Rhapsody has a solution! Create your Call Order and Rhapsody's Autopilot will automatically contact the next-in-line musician until the spot is filled.",
  },
  {
    id: 12,
    titleVariant: "",
    titleSX: { pb: 1 },
    icon: "far fa-sack-dollar",
    iconVariant: "h1",
    title: "Cost Control",
    iconSX: {
      background: gradientCollection.teal,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [2],
    subtitleSX: {},
    more: "When you use Rhapsody, you know exactly how much it will cost you; No hidden costs, no surprises at the end of the month. Rhapsody keeps your budget under control.",
  },
  {
    id: 13,
    title: "Pricing",
    titleVariant: "h3",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.orange,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 200,
    tagID: [2],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Pay for only what you want and need with no surprise fees. Starting at $0, Rhapsody offers flexible options based on your contracting needs by offering 3 different pricing plans!",
  },
  {
    id: 14,
    titleVariant: "h4",
    titleSX: {},
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.pink,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 250,
    tagID: [3, 7],
    icon: "fas fa-bolt",
    subtitle: <span>Real-Time Responses</span>,
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "After you send a call to your musicians, you can view their responses the moment they happen! Rhapsody will inform you of the entire status of your hiring by providing an overview of responses as well, all in less than a second!",
  },
  {
    id: 15,
    subtitle: "Smart Suggestions",
    icon: "fas fa-user-music",
    iconVariant: "h2",
    iconSX: {
      background: gradientCollection.purple,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 200,
    tagID: [1],
    subtitleSX: { pt: 2 },
    more: "When selecting an empty chair, Rhapsody will present you a list of Smart Suggestions as options for personnel. Smart Suggestions can be customized to appear based on a Call Order or frequently contacted musicians.",
  },
  {
    id: 16,
    title: "",
    titleVariant: "",
    titleSX: {},
    icon: "fas fa-palette",
    premium: true,
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.blue,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [4],
    subtitleSX: {},
    more: "Rhapsody offers a large range of customization for emails and communications. Personalize your messages by uploading logos, colors, or other branding to Rhapsody.",
  },
  {
    id: 17,
    titleVariant: "h4",
    titleSX: {},
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.white,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 250,
    tagID: [5, 6],
    icon: "far fa-file-export",
    subtitle: <span>Export</span>,
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Export your data at any step. Rhapsody allows you to extract important content into CSV or Excel spreadsheets including rosters and payroll.",
  },
  {
    id: 18,
    title: (
      <span>
        Batch
        <br />
        Invite
      </span>
    ),
    titleVariant: "h3",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.purple,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 200,
    tagID: [1],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Ensure that the right personnel or groups of personnel get your message. When contacting musicians, you can choose who to send a message to: select individuals, a section, an instrument family, or everyone. Great for instrument-specific requests!",
  },
  {
    id: 19,
    subtitle: <span>Multi-users</span>,
    icon: "fal fa-globe",
    iconVariant: "h2",
    iconSX: {
      background: gradientCollection.orange,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 200,
    tagID: [],
    subtitleSX: { pt: 2 },
    more: "Rhapsody allows for collaboration by adding multiple users to your account. Additional users can view and/or edit Projects and Work Sessions; a helpful tool for communicating hiring statuses across your organization!",
  },
  {
    id: 20,
    title: (
      <span>
        Report
        <br />
        Forms
      </span>
    ),
    premium: true,
    titleVariant: "h3",
    titleSX: {
      fontWeight: 600,
      background: gradientCollection.green,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    iconVariant: "h1",
    iconSX: {},
    height: 200,
    tagID: [1, 5, 6],
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Generate any report form you need in less than a second! With the Report Forms feature, Rhapsody will securely autofill musician SSN and EIN information into union, tax, and custom report forms.",
  },
  {
    id: 21,
    title: "",
    titleVariant: "",
    titleSX: {},
    icon: "far fa-history",
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.teal,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [6],
    subtitleSX: {},
    more: "When you finish a Project or Work Session, Rhapsody will keep track of every single item by archiving them. Review past Projects and Work Sessions anytime; the data is securely stored.",
  },
  {
    id: 22,
    titleVariant: "",
    titleSX: { pb: 1 },
    icon: "far fa-search-dollar",
    iconVariant: "h1",
    title: "Payment Tracker",
    iconSX: {
      background: gradientCollection.pink,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [2, 5, 7],
    subtitleSX: {},
    more: "With the Rhapsody mobile app, musicians can keep track of their payments. This information is synced across the platforms so that Contractors can keep track of and know who got paid.",
  },
  {
    id: 23,
    titleVariant: "",
    titleSX: { pb: 1 },
    icon: "fas fa-car",
    iconVariant: "h1",
    title: "Mileage",
    premium: true,
    iconSX: {
      background: gradientCollection.blue,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontSize: 56,
    },
    height: 240,
    tagID: [7],
    subtitleSX: {},
    more: "Using the free Rhapsody mobile app, musicians can keep track of their milage to and from venues. The app can automatically calculate their monthly mileage and produce a statement that is ideal for tax filing.",
  },
  {
    id: 24,
    titleVariant: "h4",
    titleSX: {},
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.white,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 250,
    tagID: [8],
    icon: "fas fa-user-headset",
    subtitle: <span>Support</span>,
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Our team is here to assist you using our live chat. Support is available Mondays - Fridays from 10:00 p.m. to 5:00 p.m. PST",
  },
  {
    id: 25,
    titleVariant: "h4",
    titleSX: {},
    iconVariant: "h1",
    iconSX: {
      background: gradientCollection.orange,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    height: 250,
    tagID: [3, 4],
    icon: "fas fa-eye",
    subtitle: <span>Read Receipt</span>,
    subtitleVariant: "h4",
    subtitleSX: { pt: 2, fontWeight: 600 },
    more: "Every time a musician opens a call from you, Rhapsody tells you that the message has been properly delivered and read by the musician.",
  },
];

export const tags = [
  { id: 1, name: "Saving Time", color: "#ffffff", icon: "fad fa-clock" },
  { id: 2, name: "Saving Money", color: "#ffffff", icon: "fad fa-wallet" },
  {
    id: 7,
    name: "Your Musicians",
    color: "#ffffff",
    icon: "fad fa-user-music",
  },
  { id: 3, name: "Reducing Errors", color: "#ffffff", icon: "fad fa-bomb" },
  { id: 4, name: "Communication", color: "#ffffff", icon: "fad fa-bullhorn" },
  { id: 5, name: "Payroll", color: "#ffffff", icon: "fad fa-money-check" },
  { id: 6, name: "Documents", color: "#ffffff", icon: "fad fa-file-alt" },
  { id: 8, name: "Security", color: "#ffffff", icon: "fad fa-shield-alt" },
];
